import { apiClient } from './client';

export async function getSystemBillingOverview() {
  const { data } = await apiClient.get('/api/system/billing/overview');
  return data.data ?? data;
}

export async function getBillingInvoices(params = {}) {
  const { data } = await apiClient.get('/api/system/billing/invoices', { params });
  return data;
}

export async function createBillingInvoice(payload) {
  const { data } = await apiClient.post('/api/system/billing/invoices', payload);
  return data.data ?? data;
}

export async function previewManualBankTransferInvoice(payload) {
  const { data } = await apiClient.post('/api/system/billing/invoices/manual-bank-transfer/preview', payload);
  return data;
}

export async function createManualBankTransferInvoice(payload) {
  const { data } = await apiClient.post('/api/system/billing/invoices/manual-bank-transfer', payload);
  return data;
}

export async function getBillingInvoiceAccountantEmail(invoiceId) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${invoiceId}/accountant-email`);
  return data;
}

export async function createManualBankTransferTestInvoice(payload) {
  const { data } = await apiClient.post('/api/system/billing/invoices/manual-bank-transfer-test', payload);
  return data;
}

export async function registerExternalAccountingInvoice(payload) {
  const { data } = await apiClient.post('/api/system/billing/invoices/external-accounting', payload);
  return data;
}

export async function getBillingInvoice(id) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${id}`);
  return data.data ?? data;
}

export async function updateBillingInvoice(id, payload) {
  const { data } = await apiClient.put(`/api/system/billing/invoices/${id}`, payload);
  return data.data ?? data;
}

export async function updateBillingInvoiceLines(id, payload) {
  const { data } = await apiClient.put(`/api/system/billing/invoices/${id}/lines`, payload);
  return data.data ?? data;
}

export async function markBillingInvoicePaid(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/billing/invoices/${id}/mark-paid`, payload);
  return data.data ?? data;
}

export async function voidBillingInvoice(id, payload = {}) {
  const { data } = await apiClient.post(`/api/system/billing/invoices/${id}/void`, payload);
  return data.data ?? data;
}

export async function downloadBillingInvoice(id) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${id}/download`);
  return data.data ?? data;
}

export async function generateBillingInvoicePdf(id) {
  const { data } = await apiClient.post(`/api/system/billing/invoices/${id}/pdf`);
  return data;
}

export async function downloadBillingInvoicePdf(id) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${id}/pdf`, {
    responseType: 'blob',
  });
  return data;
}

export async function getCustomerBillingProfile(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/billing-profile`);
  return data.data ?? data;
}

export async function updateCustomerBillingProfile(customerId, payload) {
  const { data } = await apiClient.put(`/api/system/customers/${customerId}/billing-profile`, payload);
  return {
    profile: data.data ?? data,
    tax_preview: data.tax_preview ?? null,
    message_key: data.message_key ?? null,
    message: data.message ?? null,
  };
}

export async function previewCustomerBillingTaxRule(customerId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/customers/${customerId}/billing-profile/tax-preview`, payload);
  return data.data ?? data;
}

export async function verifyCustomerBillingVatId(customerId) {
  const { data } = await apiClient.post(`/api/system/customers/${customerId}/billing-profile/verify-vat-id`);
  return data;
}

export async function getCustomerBillingOverview(customerId) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/billing-overview`);
  return data.data ?? data;
}

export async function getCustomerInvoices(customerId, params = {}) {
  const { data } = await apiClient.get(`/api/system/customers/${customerId}/invoices`, { params });
  return data;
}

export async function getTenantBillingOverview(tenantId) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/billing-overview`);
  return data.data ?? data;
}

export async function getPortalBillingOverview() {
  const { data } = await apiClient.get('/api/customer-portal/billing/overview');
  return data.data ?? data;
}

export async function getPortalCustomerBillingOverview(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/billing-overview`);
  return data.data ?? data;
}

export async function getPortalCustomerBillingProfile(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/billing-profile`);
  return data.data ?? data;
}

export async function updatePortalCustomerBillingProfile(customerId, payload) {
  const { data } = await apiClient.put(`/api/customer-portal/customers/${customerId}/billing-profile`, payload);
  return data.data ?? data;
}

export async function getPortalCustomerInvoices(customerId, params = {}) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/invoices`, { params });
  return data;
}

export async function getPortalCustomerInvoice(customerId, invoiceId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/invoices/${invoiceId}`);
  return data.data ?? data;
}

export async function downloadPortalCustomerInvoice(customerId, invoiceId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/invoices/${invoiceId}/download`);
  return data.data ?? data;
}

export async function downloadPortalCustomerInvoicePdf(customerId, invoiceId) {
  const { data } = await apiClient.get(
    `/api/customer-portal/customers/${customerId}/invoices/${invoiceId}/pdf`,
    { responseType: 'blob' },
  );
  return data;
}

export async function getPaymentMethods() {
  const { data } = await apiClient.get('/api/system/billing/payment-methods');
  return data.data ?? data;
}

export async function markInvoicePaidManual(invoiceId, payload) {
  const { data } = await apiClient.post(`/api/system/billing/invoices/${invoiceId}/mark-paid-manual`, payload);
  return data.data ?? data;
}

export async function createSystemStripeCheckoutSession(invoiceId, payload = {}) {
  const { data } = await apiClient.post(`/api/system/billing/invoices/${invoiceId}/stripe-checkout-session`, payload);
  return data.data ?? data;
}

export async function getInvoicePaymentStatus(invoiceId) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${invoiceId}/payment-status`);
  return data.data ?? data;
}

export async function getInvoicePaymentEvents(invoiceId) {
  const { data } = await apiClient.get(`/api/system/billing/invoices/${invoiceId}/payment-events`);
  return data.data ?? data;
}

export async function getSubscriptionPaidPeriods(subscriptionId) {
  const { data } = await apiClient.get(`/api/system/subscriptions/${subscriptionId}/paid-periods`);
  return data.data ?? data;
}

export async function getTenantPaidPeriods(tenantId, params = {}) {
  const { data } = await apiClient.get(`/api/system/tenants/${tenantId}/paid-periods`, { params });
  return data;
}

export async function getBillingPaidPeriods(params = {}) {
  const { data } = await apiClient.get('/api/system/billing/paid-periods', { params });
  return data;
}

export async function getBillingPaymentEvents(params = {}) {
  const { data } = await apiClient.get('/api/system/billing/payment-events', { params });
  return data;
}

export async function recalculateSubscriptionPaymentStatus(subscriptionId) {
  const { data } = await apiClient.post(`/api/system/subscriptions/${subscriptionId}/recalculate-payment-status`);
  return data.data ?? data;
}

export async function getPortalPaymentMethods(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/payment-methods`);
  return data.data ?? data;
}

export async function getPortalSavedCard(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/billing/saved-card`);
  return data.data ?? data;
}

export async function createPortalSavedCardSetup(customerId, payload) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/billing/saved-card/setup-session`,
    payload,
  );
  return data;
}

export async function revokePortalSavedCard(customerId, methodId) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/billing/saved-card/${methodId}/revoke`,
  );
  return data;
}

export async function detachPortalSavedCard(customerId, methodId) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/billing/saved-card/${methodId}/detach`,
  );
  return data;
}

export async function getPortalPaidPeriods(customerId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/paid-periods`);
  return data.data ?? data;
}

export async function getPortalInvoicePaymentStatus(customerId, invoiceId) {
  const { data } = await apiClient.get(`/api/customer-portal/customers/${customerId}/invoices/${invoiceId}/payment-status`);
  return data.data ?? data;
}

export async function createPortalStripeCheckoutSession(customerId, invoiceId, payload = {}) {
  const { data } = await apiClient.post(
    `/api/customer-portal/customers/${customerId}/invoices/${invoiceId}/stripe-checkout-session`,
    payload,
  );
  return data.data ?? data;
}
